<template>
  <div class="page_content change-password-section">
    <div class="page-content-section row">
      <b-container fluid>
        <b-row>
          <b-col cols="12" class="form-field-section">
            <b-card>
              <div class="row field-row">
                <div class="col-5 title-column">
                  <label id="contactEmail">{{ $t('email') }}</label>
                </div>
                <div class="col-6 field-column email-value">
                  <span aria-labelledby="contactEmail">{{ email }}</span>
                </div>
              </div>
              <div class="row field-row">
                <div class="col-5 title-column">
                  <label id="primaryPhoneNumber">{{ $t('phone') }}</label>
                </div>
                <div class="col-6 field-column">
                  <input v-model.trim="form.primaryPhoneNumber" aria-labelledby="primaryPhoneNumber" :placeholder="$t('phone')" />
                </div>
              </div>
              <div class="row field-row">
                <div class="col-5 title-column">
                  <label id="linkedIn">{{ $t('linkedin') }}</label>
                </div>
                <div class="col-6 field-column">
                  <input v-model.trim="form.linkedIn" aria-labelledby="linkedIn" placeholder="https://" />
                </div>
              </div>
              <div class="row field-row">
                <div class="col-5 title-column">
                  <label id="street">{{ $t('street') }}</label>
                </div>
                <div class="col-6 field-column">
                  <input v-model.trim="form.street" aria-labelledby="street" :placeholder="$t('street')" />
                </div>
              </div>
              <div class="row field-row">
                <div class="col-5 title-column">
                  <label id="city">{{ $t('city') }}</label>
                </div>
                <div class="col-6 field-column">
                  <input v-model.trim="form.city" aria-labelledby="city" :placeholder="$t('city')" />
                </div>
              </div>
              <div class="row field-row">
                <div class="col-5 title-column">
                  <label id="state">{{ $t('state') }}</label>
                </div>
                <div class="col-6 field-column">
                  <input v-model.trim="form.state" aria-labelledby="state" :placeholder="$t('state')" />
                </div>
              </div>
              <div class="row field-row">
                <div class="col-5 title-column">
                  <label id="country">{{ $t('country') }}</label>
                </div>
                <div class="col-6 field-column">
                  <input v-model.trim="form.country" aria-labelledby="country" :placeholder="$t('country')" />
                </div>
              </div>
              <div class="row field-row">
                <div class="col-5 title-column">
                  <label id="zip">{{ $t('zip') }}</label>
                </div>
                <div class="col-6 field-column">
                  <input v-model.trim="form.zip" aria-labelledby="zip" :placeholder="$t('zip')" />
                </div>
              </div>
              <div class="btn-container">
                <button class="btn btn-primary" :disabled="saving" aria-label="save" @click="saveContactInfo">{{ $t('save') }}</button>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import '../../../assets/module/css/user/changePassword.min.css'
import { mapActions } from 'vuex'

export default {
  name: 'userContactInfo',
  data () {
    return {
      saving: false,
      form: {
        primaryPhoneNumber: '',
        linkedIn: '',
        street: '',
        city: '',
        state: '',
        country: '',
        zip: ''
      },
      email: ''
    }
  },
  methods: {
    ...mapActions([
      'loadUpdateUserContactInfo'
    ]),
    loadFromUser (user) {
      let source = user || {}
      this.email = source.eMail || source.email || ''
      this.form.primaryPhoneNumber = source.primaryPhoneNumber || ''
      this.form.linkedIn = source.linkedIn || ''
      this.form.street = source.street || ''
      this.form.city = source.city || ''
      this.form.state = source.state || ''
      this.form.country = source.country || ''
      this.form.zip = source.zip || ''
    },
    reset () {
      this.saving = false
      this.loadFromUser({})
    },
    saveContactInfo () {
      if (this.saving) {
        return
      }
      this.saving = true
      this.loadUpdateUserContactInfo({
        primaryPhoneNumber: this.form.primaryPhoneNumber,
        linkedIn: this.form.linkedIn,
        street: this.form.street,
        city: this.form.city,
        state: this.form.state,
        country: this.form.country,
        zip: this.form.zip
      }).then(res => {
        this.saving = false
        if (!res) {
          this.$notify({
            group: 'notify',
            type: 'error',
            title: '',
            text: 'Unable to update contact information.'
          })
          return
        }
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: 'Contact information successfully updated!'
        })
        this.$emit('saved', res)
        this.$root.$emit('closeContactInfoModal')
      }).catch(() => {
        this.saving = false
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: 'Unable to update contact information.'
        })
      })
    }
  }
}
</script>

<style scoped>
  .email-value {
    padding-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/app/user/components/UserContactInfo.vue